<template>
	<div :class="[options.textSizeClass]">
		<span v-if="!hideCustomer">
			{{ customerName }}
			<br />
		</span>
		{{ fullname }}
	</div>
</template>

<script>
	import { get } from 'vuex-pathify'

	export default {
		name: 'UserName',
		props: {
			options: {
				type: Object,
				default: () => { return { textSizeClass: 'text-h6' } },
			},
			hideCustomer: Boolean
		},
		data: () => ({}),
		computed: {
			...get('auth', [
				'getCurrentUser',
			]),
			fullname() {
				var user = this.getCurrentUser
				if (user && user.userData) { return `${user.userData.fullName}` }
				return ''
			},
			customerName() {
				var user = this.getCurrentUser
				if (user && user.userData && user.userData.customer) { return `${user.userData.customer.name}` }
				return ''
			},
		},
	}
</script>
